"use client";

import React from "react";
import { FileText, ScanFace, Cloud } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "AI-baserad Riskbedömning",
  description: "Sänk dina försäkringspremier med vår avancerade AI-analys som förutser risker mer exakt än traditionella modeller. Genom att analysera kördata i realtid kan vi erbjuda helt skräddarsydda lösningar för din autonoma vagnpark.",
  buttonText: "Optimera din premie",
  buttonLink: "/CheaperInsurancePage",
  icon: FileText
}, {
  title: "Flottautomatiserad Försäkring",
  description: "Hantera försäkringar för hundratals autonoma fordon med ett enda klick. Vårt system integreras direkt med din mjukvara för att automatiskt uppdatera täckning baserat på fordonens operativa status och geografiska läge.",
  buttonText: "Hantera din flotta",
  buttonLink: "/BecomeOperatorPage",
  icon: ScanFace
}, {
  title: "Realtidsjusterade Premier",
  description: "Betala bara för den faktiska risken. Med våra dynamiska algoritmer justeras din premie sekund för sekund baserat på väderförhållanden, trafikintensitet och fordonshälsa, vilket maximerar din lönsamhet per körd kilometer.",
  buttonText: "Se affärsfallet",
  buttonLink: "/RobotaxiProgressAndBusinessCasePage",
  icon: Cloud
}];
function FeatureRow({
  feature,
  index
}: {
  feature: (typeof features)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="147528" ref={ref} data-index={index} className={`flex flex-col lg:flex-row border-b border-muted last:border-b-0 transition-all duration-300 ease-out hover:shadow-md ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <div className="flex-1 p-8 md:p-16 lg:p-24 flex flex-col justify-center items-start lg:border-r border-muted bg-card">
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-foreground mb-6 leading-tight">
          {feature.title}
        </h3>
        <p className="text-base md:text-lg text-muted-foreground mb-10 max-w-2xl leading-[1.6]">
          {feature.description}
        </p>
        <Button asChild variant="ghost" className="border border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-[3px] px-8 py-6 text-base font-bold transition-colors">
          <Link to={feature.buttonLink}>{feature.buttonText}</Link>
        </Button>
      </div>
      <div className="flex-1 p-12 md:p-16 lg:p-24 flex items-center justify-center bg-card">
        <feature.icon className="w-40 h-40 md:w-56 md:h-56 text-primary" strokeWidth={1} />
      </div>
    </div>;
}
export default function Funktioner() {
  return <section id="försäkringserbjudanden" className="bg-secondary py-12 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-[1400px] mx-auto bg-card rounded-[3px] border border-muted overflow-hidden">
        <div className="flex flex-col">
          {features.map((feature, i) => <FeatureRow key={i} feature={feature} index={i} />)}
        </div>
      </div>
    </section>;
}